import { Box, CircularProgress, Stack, Typography } from "@mui/material"
import { TabledRepeat } from "lib/@components/tabled-repeat/tabled-repeat"
import { ScopedScheduleRow } from "authoring/routes/project/scoped-schedules/scoped-schedule-row"
import { getDraftOrPublishedSchedules } from "authoring/routes/project/controller/get-draft-or-published-schedules"
import { refreshOnlyFor } from "lib/graphql/api"
import { IS_LOADING } from "lib/graphql/return-is-loading-on-each-request"
import { withInitialValue } from "lib/graphql/with-initial-value"
import { If, Else } from "lib/@components/switch"
import { MacroExpander } from "authoring/routes/macro/components/macro-expander"
import { useParams } from "react-router"

const tableHeaders = [
    { title: <Typography variant="subtitle1">Schedule</Typography> },
    { title: <Typography variant="subtitle1">Code</Typography> },
    { title: <Typography variant="subtitle1">Tasks</Typography> },
    { title: <Typography variant="subtitle1">Status</Typography> },
    { title: "" },
    { title: "" },
    { title: "" },
]

export function AffectedSchedulesList({ scheduleIds }) {
    const { projectId } = useParams()
    const schedulesResult = getDraftOrPublishedSchedules.useResults(
        { projectId, scheduleIds },
        refreshOnlyFor(projectId),
        withInitialValue(IS_LOADING)
    )

    return (
        <Stack spacing={1} sx={{ mt: 2 }}>
            <Typography variant="h6" ml={3}>
                Affected Schedules
            </Typography>
            <If value={schedulesResult === IS_LOADING}>
                <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
                    <CircularProgress />
                </Box>
                <Else>
                    <MacroExpander>
                        <TabledRepeat
                            items={schedulesResult ?? []}
                            itemPass="schedule"
                            itemComponent={<ScopedScheduleRow selectable={false} />}
                            tableHeaders={tableHeaders}
                            paged
                            alternating={false}
                            headerStyles={{ backgroundColor: "background.paper" }}
                            sx={{ "& tr td.MuiTableCell-root:last-of-type": { px: 0 } }}
                        />
                    </MacroExpander>
                </Else>
            </If>
        </Stack>
    )
}
